import React, { memo } from 'react'
import { string, object, number, any } from 'prop-types'

import { BodyText, CaptionText, Row, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

const TextBadge = memo((props) => {
  const { title, desc, date, expiry, status, badge } = props

  return (
    <div className="text-badge-container" key={title}>
      <Row>
        <Col md={8} xs={8}>
          <CaptionText>
            {date}
            {status && status === 'CLOSED' && (
              <span className="requestHistory-text-divider">
                <Message
                  id="dar.history.request.status.expiry"
                  count={expiry}
                />
              </span>
            )}
          </CaptionText>
          <BodyText strong>
            <Message id="dar.history.request.title" count={title} />
          </BodyText>
          <BodyText>{desc}</BodyText>
        </Col>
        {badge}
      </Row>
    </div>
  )
})

TextBadge.propTypes = {
  title: string,
  desc: any,
  date: string,
  status: string,
  expiry: number,
  badge: object,
}

TextBadge.displayName = 'TextBadge'

export default TextBadge
